import { useEffect, useState, useCallback } from "react";
import { formatDateTypeEnum } from "../../enums/general/formatDateTypeEnum";
import { chargingTransactioStatusEnum } from "../../enums/transactions/chargingTransactions/chargingTransactioStatusEnum";
import datesHelper from "../../utils/helpers/dates.helper";
import KeyValueTextElement from "../common/KeyValueTextElementComponent";

export const ChargingTransactionDataComponent = ({ props }) => {
  const { transactionDetails, chargePoint, lastUpdateTime } = props;
  const [chargeTime, setChargeTime] = useState();

  const calculateChargingTime = useCallback(() => {
    // Guard: Only calculate if transactionDetails exists
    if (!transactionDetails || !transactionDetails.startTime) {
      return;
    }
    
    let startChargingTime = new Date(transactionDetails.startTime);
    let endChargingTime = transactionDetails.endTime ? new Date(transactionDetails.endTime) : new Date();
    const chargingTime = datesHelper.getTimeDuration(startChargingTime, endChargingTime);
    setChargeTime(chargingTime);
  }, [transactionDetails]);

  useEffect(() => {
    if (transactionDetails && transactionDetails.startTime) {
      calculateChargingTime();
    }
  }, [transactionDetails, calculateChargingTime]);

  useEffect(() => {
    if (transactionDetails && transactionDetails.startTime && !transactionDetails.endTime) {
      // case transaction has start time but not end time => run transaciton time interval
      const interval = setInterval(() => {
        calculateChargingTime();
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [transactionDetails, calculateChargingTime]);

  const getStatusDetailsValue = () => {
    // first, return the status by the transaction status when it not on progress (status not equal to success)
    if (transactionDetails?.status !== chargingTransactioStatusEnum.Success) {
      switch (transactionDetails?.status) {
        case chargingTransactioStatusEnum.Pending:
          return "ממתין לתחילת טעינה";
        case chargingTransactioStatusEnum.Pending:
          return "שגיאה בטעינה! אנא צור קשר עם התמיכה";
        case chargingTransactioStatusEnum.Finished:
          return "טעינה זו הסתיימה! מתחיל תהליך חיוב בעבור הטעינה";
        case chargingTransactioStatusEnum.WaitingToChargeToken:
          return "מחייב כרטיס אשראי";
        case chargingTransactioStatusEnum.WaitingToCreateInvoice:
          return "יוצר קבלה";
        case chargingTransactioStatusEnum.Complete:
          return "טעינה זו הסתיימה! נתוני הטעינה ניתנים לצפייה בלבד";
        default:
          return "ממתין לקבלת פרטים נוספים...";
      }
    }
    //  seconed, return the status of the connector when the charging transaciton is in progress (status success)
    return chargePoint?.connectorStatus ? statusTranslations[chargePoint.connectorStatus] : "ממתין לקבלת פרטים נוספים...";
  };

  const getLastUpdateDetailsValue = () => {
    const formatType = transactionDetails?.status !== chargingTransactioStatusEnum.Success ? formatDateTypeEnum.dateTime : formatDateTypeEnum.time;
    return datesHelper.formateTimeStamp(lastUpdateTime, formatType);
  };

  return (
    <div className="flexColumn" style={{ gap: "var(--spacingMd)" }}>
      {chargePoint && (
        <>
          <KeyValueTextElement keyLabel="שם עמדת טעינה:" valueText={chargePoint.externalApi_ChargePointDetailsDTO?.nickname} />
          <KeyValueTextElement keyLabel="מספר סריאלי:" valueText={chargePoint.serialNumber} showBorder />
        </>
      )}

      {!transactionDetails && <span>טוען פרטי טעינה...</span>}
      {transactionDetails && (
        <>
          <KeyValueTextElement keyLabel="סטטוס:" valueText={getStatusDetailsValue()} showBorder />
          <KeyValueTextElement keyLabel='סה"כ אנרגיה נצרכת:' valueText={`${transactionDetails.kwh}kWh`} showBorder />
          <KeyValueTextElement keyLabel="זמן טעינה:" valueText={chargeTime ? chargeTime : "מחשב זמן טעינה.."} showBorder />
          <KeyValueTextElement keyLabel={`עלות טעינה ${transactionDetails?.status !== chargingTransactioStatusEnum.Complete ? "משוערת" : ""}:`} valueText={`${transactionDetails.totalPrice}₪`} showBorder />
          <KeyValueTextElement keyLabel="עדכון אחרון:" valueText={getLastUpdateDetailsValue()} />
          {transactionDetails.invoiceUrl && (
            <button className="buttonContainer marginTop20 flexRow justifyCenter" style={{ marginTop: "var(--spacingLg)" }}>
              <a href={transactionDetails.invoiceUrl} download target="_blank" rel="noopener noreferrer">
                לחץ כאן להורדת חשבונית הטעינה
              </a>
            </button>
          )}
        </>
      )}
    </div>
  );
};

const statusTranslations = {
  Online: "מחובר",
  Offline: "מנותק",
  Available: "זמין",
  Preparing: "מחובר",
  Charging: "טוען",
  SuspendedEV: "מושהה על ידי הרכב",
  SuspendedEVSE: "מושהה על ידי המטען",
  Finishing: "טעינה הסתיימה",
  Reserved: "שמור",
  Unavailable: "לא זמין",
  Faulted: "תקול",
};

export default ChargingTransactionDataComponent;
